import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem
} from './env-config'

const csrfTokenKey = 'auth.csrf_token'

export function getCsrfToken() {
  return getLocalStorageItem(csrfTokenKey) || ''
}

export function setCsrfToken(token: string) {
  setLocalStorageItem(csrfTokenKey, token)
}

export function clearCsrfToken() {
  removeLocalStorageItem(csrfTokenKey)
}

////////////////////////////////

export function isSSOCallback() {
  const p = new URLSearchParams(window.location.search)
  return p.has('oauth_callback')
}

export function getBaseURL() {
  return `${window.location.protocol}//${window.location.host}${window.location.pathname}`
}

export function getRedirectURL() {
  return `${getBaseURL()}?oauth_callback=1`
}

/** 去掉 ?oauth_callback&code&state 等，保留 pathname + hash（登录成功后地址栏不留授权码） */
export function clearOAuthCallbackSearchParams() {
  const u = new URL(window.location.href)
  if (!u.searchParams.has('oauth_callback')) return
  u.search = ''
  window.history.replaceState(
    window.history.state,
    document.title,
    `${u.pathname}${u.hash}`
  )
}

////////////////////////////////

const loginFromKey = 'login.from'

export function getLoginFrom() {
  return getLocalStorageItem(loginFromKey) || '/'
}

export function setLoginFrom(val: string) {
  setLocalStorageItem(loginFromKey, val)
}

export function clearLoginFrom() {
  removeLocalStorageItem(loginFromKey)
}
